import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { ValidationErrorType } from '../../../types';
import { ValidationErrorPipe } from './validation-error.pipe';

@Component({
  selector: 'fr8bot-ui-validation-error',
  imports: [TranslatePipe, ValidationErrorPipe],
  templateUrl: './validation-error.component.html',
  styleUrl: './validation-error.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ValidationErrorUIComponent {
  readonly error = input<ValidationErrorType | null>(null);
}
